export default _this => {
  _this.columns = [
    'report_time_start',
    'report_time_end',
    'client',
    'name',
    'model',
    'serialNumber',
    'ip',
    'total',
    'total_start',
    'total_end',
    'black_start',
    'black_end',
    'color_start',
    'color_end',
    'color',
    'black',
    // "blacktoner",
    // "blacktoner_per_black",
    // "pages_per_full_black_toner",
    'printed',
    'copied',
    'faxed',
    'scanned'
  ]

  const data = []
  _this.clients.forEach(async client => {
    const computer = client.computer
    if (computer && computer.printers) {
      for (let printer of computer.printers) {
        if (printer.macAddress || (printer.parsed && printer.parsed.serialNumber)) {
          let active = true
          let name = ''
          const printerId = printer.id
          let printerParsed = printer.parsed
          const model = printerParsed.model
          printerParsed.model = model
          if (_this.user.settings && _this.user.settings.printers) {
            const printerSettings = _this.user.settings.printers[printerId]
            if (printerSettings) {
              printerParsed['settings'] = printerSettings
              if (printerSettings.hasOwnProperty('active')) {
                active = printerSettings.active
              }
              if (printerSettings.name) {
                name = printerSettings.name
              }
            }
          }
          if (active) {
            const row = {
              DT_RowId: printerId,
              path: printer.path,
              snapshot: printer.snapshot,
              client: client.name,
              active,
              name
            }

            if (printerParsed.model) {
              if (!printerParsed.manufacturer) {
                let model = printerParsed.model.split(' ')
                printerParsed.manufacturer = model[0]
                model.shift()
                printerParsed.model = model.join(' ')
              }
              if (
                printerParsed.serialNumber &&
                printerParsed.model.indexOf(printerParsed.serialNumber) != -1
              ) {
                printerParsed.model = printerParsed.model
                  .replace(printerParsed.serialNumber, '')
                  .trim()
              }
              printer.manufacturer = printerParsed.manufacturer
              printer.model = printerParsed.model
            }

            if (printerParsed.serialNumber) {
              printerParsed.serialNumber = printerParsed.serialNumber.split(
                '-'
              )[0]
            }

            row.manufacturer = printerParsed.manufacturer
            row.model = printerParsed.model
            row.serialNumber = printerParsed.serialNumber
            row.ip = printerParsed.ip

            data.push(row)
          }
        }
      }
    }
  })
  _this.data = data

  $.each(_this.unique(_this.columns), (index, column) => {
    let title = column
    let uniqueColumn = { name: column, data: column }
    let visible = true
    switch (column) {
      case 'client':
        visible = !_this.desktop
        break
      case 'report_time_start':
      case 'report_time_end':
        uniqueColumn['render'] = (data, type, row, meta) => {
          if (type !== 'sort') {
            return data ? moment(data).format('L HH:mm') : ''
          }
          return data || ''
        }
        break
      case 'total':
      case 'color':
      case 'black':
      case 'printed':
      case 'copied':
      case 'faxed':
      case 'scanned':
      // case "pages_per_full_black_toner":
        uniqueColumn['defaultContent'] = 0
        uniqueColumn['render'] = data => (data ? data.toLocaleString() : 0)
        break
      // case "blacktoner":
      //   uniqueColumn["defaultContent"] = `%0`;
      //   uniqueColumn["render"] = data => `%${data || 0}`;
      //   break;
      // case "blacktoner_per_black":
      //   uniqueColumn["defaultContent"] = "0.0000";
      //   uniqueColumn["render"] = data => data;
      //   break;
      case 'model':
        uniqueColumn['render'] = (data, type, row, meta) =>
          `${row.manufacturer || ''} ${row.model || ''}`
        break
      case 'name':
        visible = false
        break
      case 'total_start':
      case 'total_end':
        uniqueColumn['render'] = data => (data ? data.toLocaleString() : 0)
        break
      case 'black_start':
      case 'black_end':
      case 'color_start':
      case 'color_end':
        visible = false
        uniqueColumn['render'] = data => (data ? data.toLocaleString() : 0)
        break
    }
    uniqueColumn['title'] = _this.t(title)
    uniqueColumn['visible'] = visible
    _this.uniqueColumns.push(uniqueColumn)
  })

  const { options } = _this.createTableProperties(_this)
  options.columnDefs = [
    {
      defaultContent: '',
      targets: '_all'
    }
  ]
  options.columns.shift()
  delete options.select
  delete options.order
  _this.table = $(_this.$el)
    .find('table')
    .DataTable(options)
  let buttons1 = []
  buttons1 = [
    {
      text: '<span />',
      className: 'hiddenButton'
    }
  ]
  _this.createButtons(_this, buttons1)
  _this.table
    .buttons('.hiddenButton')
    .nodes()
    .css('pointer-events', 'none')

  const tableId = _this.table
    .containers()[0]
    .getAttribute('id')
    .split('_')[2]

  $(`<div class="dt-buttons btn-group dt-header-buttons right">
            <div id="usage-date-range" class="date-range" style="background: #fff; cursor: pointer; border: 1px solid #ccc; padding: 0 10px; padding-right: 6px;">
            <i class="icon s7-date"></i>&nbsp;
            <span></span> <i class="fa fa-caret-down"></i>
        </div>
    </div>`).prependTo(`#DataTables_Table_${tableId}_wrapper`)

  const usageDateRangeCb = (start, end) => {
    $('#usage-date-range span').html(
      start.format('ll') + ' - ' + end.format('ll')
    )
  }

  $('#usage-date-range').daterangepicker(
    {
      startDate: _this.startDate,
      endDate: _this.endDate,
      ranges: _this.ranges,
      opens: 'left'
    },
    usageDateRangeCb
  )

  usageDateRangeCb(_this.startDate, _this.endDate)

  const applyUsageRangeDate = async (startDate, endDate) => {
    _this.table.processing(true)
    const users = _this.clients.map(client => client.snapshot.id)
    const printersResponse = await _this.serviceRequest('getPrintersUsage', {
      users,
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD')
    })
    const printersUsage = _this.arrayToObject(printersResponse, [
      'computer',
      'printer'
    ])
    _this.table.data().map((value, index) => {
      const printerRef = _this.$store.state.db.doc(value.path)
      const printersUsageId = `${printerRef.parent.parent.id}/${value.DT_RowId}`
      const printerUsage = printersUsage[printersUsageId]
      if (printerUsage) {
        delete printerUsage.user
        delete printerUsage.computer
        delete printerUsage.printer
        printerUsage.report_time_start =
          moment(printerUsage.report_time_start).unix() * 1000
        printerUsage.report_time_end =
          moment(printerUsage.report_time_end).unix() * 1000
        _this.table
          .row((idx, data) => data.DT_RowId === value.DT_RowId)
          .data(Object.assign(value, printerUsage))
      } else {
        _this.table
          .row((idx, data) => data.DT_RowId === value.DT_RowId)
          .data(
            Object.assign(value, {
              total: 0,
              color: 0,
              black: 0,
              printed: 0,
              copied: 0,
              faxed: 0,
              scanned: 0
            })
          )
      }
    })
    const filteredStartData = _this.table
      .column('report_time_start:name')
      .data()
      .filter(value => moment(value).isAfter(moment(startDate).startOf('day')))
    let startDateVal = ''
    for (var count = 0; count < filteredStartData.length; count++) {
      startDateVal += moment(filteredStartData[count]).format('L HH:mm') + '|'
    }
    startDateVal = startDateVal.slice(0, -1)
    _this.table
      .column('report_time_start:name')
      .search(
        startDateVal ? '^' + startDateVal + '$' : '^' + '-' + '$',
        true,
        false,
        true
      )
    const filteredEndData = _this.table
      .column('report_time_end:name')
      .data()
      .filter(value => moment(value).isBefore(moment(endDate).endOf('day')))
    let endDateval = ''
    for (var count = 0; count < filteredEndData.length; count++) {
      endDateval += moment(filteredEndData[count]).format('L HH:mm') + '|'
    }
    endDateval = endDateval.slice(0, -1)
    _this.table
      .column('report_time_end:name')
      .search(
        endDateval ? '^' + endDateval + '$' : '^' + '-' + '$',
        true,
        false,
        true
      )
    _this.table
      .column('total:name')
      .order('desc')
      .draw()
    _this.table.processing(false)
  }

  $('#usage-date-range').on('apply.daterangepicker', (event, picker) => {
    event.preventDefault()
    const { startDate, endDate } = picker
    applyUsageRangeDate(startDate, endDate)
  })

  if (_this.data && _this.data.length < 1000) {
    applyUsageRangeDate(_this.startDate, _this.endDate)
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Usage.js